import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import api from "../../../apis/api";
import moment from "moment";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fullcalendar/bootstrap5/main.css";
import "@fullcalendar/daygrid/main.css";
import "../../../style/LeaderCalendar.css";
import interactionPlugin from "@fullcalendar/interaction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Notifications from "../../../components/common/Notifications";
const loginUser = JSON.parse(localStorage.getItem("user"));

const LeaderEmployeeCalendar = () => {
  const calendarRef = useRef();
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [leaveMap, setLeaveMap] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [filterType, setFilterType] = useState("Me");

  const [showModal, setShowModal] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reason, setReason] = useState("");
  const [fromdutytype, setfromdutytype] = useState("1");
  const [todutytype, settodutytype] = useState("1");
  const [datediff, setdatediff] = useState(0);
  const [error, setError] = useState(null);
  const [leaveName, setLeaveName] = useState('');
  const [leaveMapFiltered, setLeaveMapFiltered] = useState([]);
  const [isCurrentMonth, setIsCurrentMonth] = useState(true);
  const [formValidation, setFormValidation] = useState({});
  const globalMinDate = new Date('2025-12-27');
  const leaveTypeOptions = [
    { value: "Me", label: "Me" },
    { value: "My Organization", label: "My Organization" },
    { value: "AddedByMe", label: "Added by Me" }
  ];

  const dutyTypeOptions = [
    { value: "1", label: "Full Day" },
    { value: "2", label: "Half Day" }
  ];

  useEffect(() => {
    loadCalendar();
  }, [filterType]);
  useEffect(() => {
    const btn = document.querySelector(".fc-todayBtn-button");
    if (btn) btn.disabled = isCurrentMonth;
  }, [isCurrentMonth]);

  const loadCalendar = async () => {
    const res = await api.dbCalendarYear().GetAllPlannedLeaveAppply();
    let plannedLeaves = res.data || [];

    if (filterType === "Me") {
      plannedLeaves = plannedLeaves.filter(
        leave => leave.employeeId === parseInt(loginUser.EmployeeId)
      );
    }

    if (filterType === "AddedByMe") {
      plannedLeaves = plannedLeaves.filter(
        leave => leave.createdById === parseInt(loginUser.EmployeeId)
      );
    }

    /* My Organization = no filter */


    const map = {};
    const events = [];

    plannedLeaves.forEach((leave) => {
      const from = moment(leave.fromDate).local().startOf("day");
      const to = moment(leave.toDate).local().startOf("day");


      let d = from.clone();
      while (d.isSameOrBefore(to)) {
        if (![0, 6].includes(d.day())) {
          const key = d.format("YYYY-MM-DD");
          if (!map[key]) map[key] = [];
          map[key].push(leave);
        }
        d.add(1, "day");
      }
    });

    Object.keys(map).forEach((date) => {
      events.push({
        start: date,
        allDay: true,
        title: "",
        extendedProps: { count: map[date].length },
      });
    });

    setLeaveMap(map);
    setCalendarEvents(events);
  };
  const resetForm = () => {
    setSelectedEmployee("");
    setSelectedLeaveType("");
    setEmployeeList([]);
    setLeaveTypeList([]);

    setFromDate("");
    setToDate("");
    setfromdutytype("1");
    settodutytype("1");
    setdatediff(0);

    setReason("");
    setLeaveName("");

    setFormValidation({});
  };
  const date_diff_indays = (fromDate, toDate) => {
    const dt1 = moment(fromDate, ['YYYY-MM-DD', 'DD/MM/YYYY']);
    const dt2 = moment(toDate, ['YYYY-MM-DD', 'DD/MM/YYYY']);
    if (!dt1.isValid() || !dt2.isValid()) return 0;

    let count = 0;
    for (let m = moment(dt1); m.isSameOrBefore(dt2); m.add(1, 'days')) {
      const day = m.day();
      if (day !== 0 && day !== 6) count++;
    }
    return count;
  };
  const setFromdatechanes = (val) => {
    setFromDate(val);
    setfromdutytype("1");

    if (toDate) {
      const diff = date_diff_indays(val, toDate);
      setdatediff(diff > 0 ? diff : 0);
    }
  };
  const validateForm = () => {
    const errors = {};

    if (!selectedEmployee) {
      errors.employee = {
        isValid: false,
        errorMessage: "Employee is required"
      };
    }

    if (!selectedLeaveType) {
      errors.leaveType = {
        isValid: false,
        errorMessage: "Leave type is required"
      };
    }

    if (!fromDate) {
      errors.fromDate = {
        isValid: false,
        errorMessage: "From date is required"
      };
    }

    if (!toDate) {
      errors.toDate = {
        isValid: false,
        errorMessage: "To date is required"
      };
    }

    if (!reason || reason.trim() === "") {
      errors.reason = {
        isValid: false,
        errorMessage: "Reason is required"
      };
    }

    setFormValidation(errors);
    return Object.keys(errors).length === 0;
  };

  const setTodatechanes = (val) => {
    setToDate(val);
    settodutytype("1");

    if (fromDate) {
      const diff = date_diff_indays(fromDate, val);
      setdatediff(diff > 0 ? diff : 0);
    }
  };

  const handleonchangeFromduetytype = (type) => {
    setfromdutytype(type);
    if (fromDate && toDate) {
      let diff = date_diff_indays(fromDate, toDate);
      if (type === "2" || todutytype === "2") diff -= 0.5;
      setdatediff(diff);
    }
  };

  const handleonchangeToduetytype = (type) => {
    settodutytype(type);
    if (fromDate && toDate) {
      let diff = date_diff_indays(fromDate, toDate);
      if (type === "2" || fromdutytype === "2") diff -= 0.5;
      setdatediff(diff);
    }
  };

  const handleMarkLeave = async () => {
    setShowModal(true);

    const res = await api.task().GetEmployeeBasedOnLeaveAssignedEmpId(parseInt(loginUser.EmployeeId));
    const empOptions = res.data.filter(x => x.isActive)
      .map(emp => ({ value: emp.employeeId, label: emp.employeeName }));
    setEmployeeList(empOptions);
  };

  const handleAddLeave = async () => {
    if (!validateForm()) return;

    if (hasDuplicateLeave()) {
      setError({ ...error, message: "Leave already exists for this employee on the selected date(s).", status: 500 });
      return;
    }

    try {
      const payload = {
        EmployeeId: Number(selectedEmployee),
        LeaveTypeId: Number(selectedLeaveType),
        FromDate: moment(fromDate).format("YYYY-MM-DD"),
        ToDate: moment(toDate).format("YYYY-MM-DD"),
        FromType: String(fromdutytype),
        ToType: String(todutytype),
        DaysCount: datediff,
        Reason: reason,
        CreatedBy: loginUser.EmployeeName,
        UpdatedBy: loginUser.EmployeeName,
      };

      await api.dbCalendarYear().AddEditPlannedLeaveApply(payload);

      setShowModal(false);
      loadCalendar();
      resetForm();
    } catch (error) {
      console.error("Error applying leave", error);
    }
  };

  const handleDeleteLeave = async (leaveId, employeeName, leaveType, date) => {
    const confirmText = `Do you want to delete this leave entry?\n\nEmployee: ${employeeName}\nLeave Type: ${leaveType || 'Planned'}\nDate: ${moment(date).format("YYYY-MM-DD")}`;

    if (!window.confirm(confirmText)) return;

    try {
      await api.dbCalendarYear().DeletePlannedLeaveApply(leaveId);

      // Update local state temporarily to reflect immediate deletion
      setTransactions(prev => prev.filter(t => t.leaveRequestId !== leaveId));
      setLeaveMapFiltered(prev => prev.filter(t => t.leaveRequestId !== leaveId));

      // Refresh the calendar events
      loadCalendar();
    } catch (error) {
      console.error("Error deleting leave", error);
      alert("Failed to delete leave entry");
    }
  };

  const clearFieldError = (field) => {
    setFormValidation(prev => {
      if (!prev[field]) return prev;
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });
  };

  const hasDuplicateLeave = () => {
    if (!selectedEmployee || !fromDate || !toDate) return false;

    let d = moment(fromDate);
    const end = moment(toDate);

    while (d.isSameOrBefore(end)) {
      const key = d.format("YYYY-MM-DD");
      const leavesOnDay = leaveMap[key] || [];

      const exists = leavesOnDay.some(
        l => l.employeeId === Number(selectedEmployee)
      );

      if (exists) return true;
      d.add(1, "day");
    }

    return false;
  };
  const getToDateMin = () => {
    if (fromDate && globalMinDate) {
      return fromDate > globalMinDate ? fromDate : globalMinDate;
    }
    return fromDate || globalMinDate;
  };

  return (
    <div className="container-fluid mt-3">
      <div className="d-flex justify-content-between mb-2">
        <h5>Leave Calendar</h5>
        <div style={{ width: "200px" }}>
          <Select
            options={leaveTypeOptions}
            value={leaveTypeOptions.find(opt => opt.value === filterType)}
            onChange={(opt) => setFilterType(opt.value)}
            placeholder="Select Scope"
            isSearchable={false}
            menuPortalTarget={document.body}
            classNamePrefix="leave-select"
          />

        </div>
      </div>

      <div className="row">
        <div className="col-md-8">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, bootstrap5Plugin, interactionPlugin]}

            themeSystem="bootstrap5"
            initialView="dayGridMonth"
            eventDisplay="list-item"
            events={calendarEvents}

            headerToolbar={
              loginUser.RoleName === "Admin"
                ? { center: "title", right: "todayBtn prev,next" }
                : { left: "markLeave", center: "title", right: "todayBtn prev,next" }
            }

            customButtons={{
              markLeave: { text: "Mark Leave", click: handleMarkLeave },

              todayBtn: {
                text: "Today",
                click: () => {
                  calendarRef.current.getApi().today();
                }
              }
            }}
            datesSet={(arg) => {
              const current = moment();
              const viewDate = moment(arg.start);
              setIsCurrentMonth(
                current.month() === viewDate.month() &&
                current.year() === viewDate.year()
              );
            }}

            eventClick={(info) => {
              const key = moment(info.event.start).format("YYYY-MM-DD");
              const data = leaveMap[key] || [];
              setTransactions(data);
              setLeaveMapFiltered(data);
            }}

            eventContent={(arg) => (
              <div className="leave-count-circle">
                {arg.event.extendedProps.count}
              </div>
            )}

          />
        </div>

        <div className="col-md-4">
          <div className="leave-trans-card">

            <div className="leave-trans-header">
              <span>Leave Transactions ({transactions.length})</span>

              <div className="leave-trans-search">
                <input
                  type="text"

                  className="form-control"
                  placeholder="Search Employee"
                  onChange={(e) => {
                    const val = e.target.value.toLowerCase();
                    setTransactions(
                      leaveMapFiltered.filter(t =>
                        t.employeeName.toLowerCase().includes(val)
                      )
                    );
                  }}
                />
                <i className="bi bi-search"></i>
              </div>
            </div>

            <table className="table table-sm leave-trans-table">
              <thead style={{ background: '#e6f9f6ff' }}>
                <tr>
                  <th>Employee</th>
                  <th>Number of days</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {transactions.length === 0 && (
                  <tr><td colSpan="4" className="text-center text-muted">No records</td></tr>
                )}

                {transactions.map((t, i) => (
                  <tr key={i}>
                    <td>
                      <div className="emp-name">{t.employeeName}</div>
                      <div className="emp-role">{t.designation || ''}</div>
                    </td>
                    <td>{t.noOfDays == 1 ? "Full Day" : "Half Day"}</td>
                    <td>{t.leaveStatus}</td>
                    <td className="text-center">
                      {t.createdById === parseInt(loginUser.EmployeeId) && (
                        <i
                          className="bi bi-trash text-danger"
                          style={{ cursor: "pointer", fontSize: "1rem" }}
                          onClick={() => handleDeleteLeave(t.leaveRequestId, t.employeeName, t.leaveType, t.fromDate)}
                          title="Delete Leave"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <Notifications notifications={error} />
      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Mark Leave</h5>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>

              <div className="modal-body">

                <Select
                  classNamePrefix="leave-select"
                  value={employeeList.find(emp => emp.value === selectedEmployee) || null}
                  onChange={async (option) => {
                    const empId = option?.value || "";
                    setSelectedEmployee(empId);
                    setLeaveName(option?.label || "");
                    clearFieldError("employee");
                    if (empId) {
                      try {
                        const resLeave = await api.dbLeaveTypes().GetLeaveTypesByEmpId(parseInt(empId));
                        const leaveData = resLeave.data || [];
                        const leaveOptions = leaveData.map(lt => ({
                          value: lt.leaveTypeId,
                          label: lt.type
                        }));
                        setLeaveTypeList(leaveOptions);
                      } catch (error) {
                        console.error("Error fetching leave types by employee:", error);
                      }
                    } else {
                      setLeaveTypeList([]); // reset if no employee selected
                    }
                  }}
                  options={employeeList}
                  isSearchable={true}
                  placeholder="Select Employee"
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().startsWith(inputValue.toLowerCase())
                  }
                />
                {formValidation.employee && !formValidation.employee.isValid && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {formValidation.employee.errorMessage}
                  </span>
                )}

                <Select
                  className="mt-2"
                  options={[...leaveTypeList].sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )}
                  onChange={(o) => {
                    setSelectedLeaveType(o.value);
                    clearFieldError("leaveType");
                  }}
                  placeholder="Select Leave Type"
                  classNamePrefix="leave-select"
                />
                {formValidation.leaveType && !formValidation.leaveType.isValid && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {formValidation.leaveType.errorMessage}
                  </span>
                )}

                <div className="row mt-3">
                  <div className="col">
                    <label>From Date</label>
                    {/* <input type="date" className="form-control"
          value={fromDate}
          onChange={(e) => setFromdatechanes(e.target.value)} /> */}
                    <DatePicker
                      className="form-control"
                      selected={fromDate}
                      dateFormat="dd-MM-yyyy"

                      // minDate={new Date('2026-01-27')} // Set your start date
                      // maxDate={new Date('2026-03-31')} // Set your end date
                      // excludeDates={holidaylist}
                      onChange={(e) => {
                        if (e) {
                          e.setHours(0, 0, 0, 0); // Ensure time is 00:00:00
                          setFromdatechanes(e);
                          clearFieldError("fromDate");
                        } else {
                          setFromdatechanes(null);
                        }
                      }}
                      name="fromDate"
                    />
                    {formValidation.fromDate && !formValidation.fromDate.isValid && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {formValidation.fromDate.errorMessage}
                      </span>
                    )}


                  </div>
                  <div className="col">
                    <label>To Date</label>
                    {/* <input type="date" className="form-control"
          value={toDate}
          min={fromDate}
          onChange={(e) => setTodatechanes(e.target.value)} /> */}
                    <DatePicker
                      className="form-control"
                      selected={toDate}
                      dateFormat="dd-MM-yyyy"
                      minDate={getToDateMin()}   // ✅ respects both rules
                      // minDate={new Date('2025-12-27')} // Set your start date
                      // maxDate={new Date('2026-03-31')} // Set your end date
                      // excludeDates={holidaylist}
                      onChange={(e) => {
                        if (e) {
                          e.setHours(0, 0, 0, 0); // Ensure time is 00:00:00
                          setTodatechanes(e);
                          clearFieldError("toDate");
                        } else {
                          setTodatechanes(null);
                        }
                      }}
                      name="toDate"
                    />
                    {formValidation.toDate && !formValidation.toDate.isValid && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {formValidation.toDate.errorMessage}
                      </span>
                    )}

                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col">
                    <label>Type</label>
                    <Select
                      classNamePrefix="leave-select"
                      options={dutyTypeOptions}
                      value={dutyTypeOptions.find(opt => opt.value === fromdutytype)}
                      onChange={(opt) => handleonchangeFromduetytype(opt.value)}
                      isDisabled={
                        !fromDate ||
                        !toDate ||
                        moment(fromDate).format("YYYY-MM-DD") !== moment(toDate).format("YYYY-MM-DD")
                      }
                      placeholder="Select Type"
                      isSearchable={false}
                    />


                  </div>
                  <div className="col">
                    <label>Working Days</label>
                    <input className="form-control bg-light" readOnly value={datediff} />
                  </div>
                </div>

                <textarea className="form-control mt-3" placeholder="Reason" value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                    clearFieldError("reason");
                  }} />
                {Object.keys(formValidation).length !== 0 &&
                  formValidation.reason &&
                  !formValidation.reason.isValid && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {formValidation.reason.errorMessage}
                    </span>
                  )}

              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => { setShowModal(false); resetForm(); }}>Cancel</button>
                <button className="btn btn-primary" onClick={handleAddLeave}>Mark Leave</button>
              </div>
            </div>

          </div>
        </div>
      )}
    </div>

  );
};

export default LeaderEmployeeCalendar;
